import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaFacebook, FaTiktok } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <h3>Melodia Music</h3>
          <p>Helping you master your musical journey.</p>
        </div>

        <div className="footer-socials">
          <a
            href="https://www.instagram.com/ivanology_/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/in/ivansimangas/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://www.facebook.com/ivan.simangas/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.tiktok.com/@ivanology_?_t=8nm8z69ZLFn&_r=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok />
          </a>
        </div>
      </div>

      {/* Minimal link row */}
      <nav className="footer-links" aria-label="Footer">
        <Link to="/" onClick={scrollToTop}>
          Home
        </Link>
        <Link to="/booking" onClick={scrollToTop}>
          Lessons
        </Link>
        <Link to="/audio" onClick={scrollToTop}>
          Audio
        </Link>
        <Link to="/pricing" onClick={scrollToTop}>
          Pricing
        </Link>
        <Link to="/shop" onClick={scrollToTop}>
          Shop
        </Link>
        <Link to="/contact" onClick={scrollToTop}>
          Contact
        </Link>
      </nav>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Melodia Music. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
